export const DEFAULT_REJECTION = { orders: 0, items: 0, salesWithVat: 0, salesNoVat: 0 };

export const DEFAULT_PUNCTUALITY = {
  avgPreparationTimeSec: 0,
  earlyOrders: 0,
  lateOrders: 0,
  onTimeOrders: 0,
  punctuality: 0,
};
